/**
 * Anzeige für `DueDateTaskAssignee`, das absichtlich maskiert sein kann:
 * `display_name` ist `null` für einen externen Aufrufer, dieselbe Maskierung
 * wie `TicketAssignee` (Spec 06b, AK-567, Befund W3 aus 06a: „extern
 * entdeckt nichts" gilt auch für ein einzelnes Feld).
 *
 * `DueDateSubject.label`, `.kind` und `.path_label` bekommen hier **keine**
 * Entsprechung zu `features/tasks/labels.ts::subjectLabel` — anders als
 * `TicketSubject` sind sie nicht nullable (AK-569, Spec „Ein Termin ist keine
 * Entity": ein Grant führt bei einem Termin immer über die Sichtbarkeit des
 * Objekts, es gibt keinen Zugriffspfad, der `subject.label` maskieren
 * müsste).
 */

import type { DueDateTaskAssignee } from './api'

export function assigneeLabel(assignee: DueDateTaskAssignee | null): string | null {
  if (assignee === null) return null
  return assignee.display_name ?? 'Person ohne Namen'
}
